import { defineStore } from 'pinia';
import { getNav } from '../../api/navigation/navigations';
import type { NavigationNode } from '../../types/link';
import { useStoreConfiguration } from '../configuration/configuration';
import { watch, ref } from 'vue';

export type StoreMainNav = {
  items?: NavigationNode[];
  currentPage?: string;
};

const storeId = 'store-main-nav';
const type = 'primary';

export const useStoreMainNavigation = defineStore(storeId, () => {
  const storeConfiguration = useStoreConfiguration();
  const items = ref<StoreMainNav['items']>();
  const currentPage = ref<StoreMainNav['currentPage']>();

  async function fetchItems() {
    const { caasConfig, caasUrl, config } = storeConfiguration;

    if (!caasConfig || !caasUrl || !config) {
      console.error(`${storeId} >>> error`, 'caas configuration or URL is not available');
      return;
    }

    const { caas_navigationServiceUrl: navigationServiceUrl } = config;
    const { project, instance, stage, language, locale, prefix, currentPageUUID } = caasConfig;

    const navItems = await getNav(
      caasUrl,
      navigationServiceUrl,
      project,
      instance,
      type,
      stage,
      language,
      locale,
      prefix,
      'store-main-nav',
    );

    if (navItems) {
      items.value = navItems;
    }

    currentPage.value = currentPageUUID;
  }

  watch(storeConfiguration, () => {
    if (storeConfiguration.config && !items.value) {
      fetchItems();
    }
  });

  return {
    currentPage,
    items,
  };
});
